import React from 'react';
import {Modal} from '@enos/dpl';
import localeText from '@locale';
import {getPublicKey} from '~/utils/encrypt';
import {showChangePasswordModal} from '~/components/ChangeCipher';
import sessionStore from '~/stores/SessionStore';
import securityStore from '~/stores/SecurityStore';

export function isInitPassword() {
  if (sessionStore.currentUser.isInitPassword && !sessionStore.emailAvaiable && !sessionStore.initPasswordVisible) {
    sessionStore.toggleInitPassword(true);
    Modal.warning({
      title: localeText('COMMON.TITLE_CHANGE_CIPHER'),
      content: <div>{localeText('COMMON.TXT_CHANGE_CIPHER_NOTE')}</div>,
      okText: localeText('COMMON.BTN_CHANGE_CIPHER'),
      onOk() {
        getPublicKey().then(() => {
          securityStore.getPasswordRule(sessionStore.currentUser.id);
          showChangePasswordModal();
          sessionStore.toggleInitPassword(false);
        });
      }
    });
  }
}
